import React, { useEffect, useState } from 'react';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH } from '../constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import P from 'components/P';
import AdminMobileSearchInput from 'routes/adminMobile/components/common/AdminMobileSearchInput';
import AdminMobileTabbtnBox from 'routes/adminMobile/components/common/AdminMobileTabbtnBox';
import AdminMobileProductList from 'routes/adminMobile/components/AdminMobileProductList';
import AdminMobileRegisterBtn from 'routes/adminMobile/components/common/AdminMobileRegisterBtn';
import { requester } from 'App';

// 탭 버튼 카테고리
import categories from 'routes/adminMobile/commonVar/productCategory';

const AdminMobileStoreProduct = () => {
    const [isMounted, setMounted] = useState(false);

    // 현재 선택된 카테고리를 상태로 관리
    const [selectedCategory, setSelectedCategory] = useState(categories[0].name);
    

    // 검색어 상태 추가
    const [searchKeyword, setSearchKeyword] = useState('');
    

    // 상품 리스트와 필터링된 상품 리스트를 상태로 관리
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);

    useEffect(()=> {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            let data = { storeId: "root" }
            requester.findAllProducts(data, (result) => {
                
                setProducts(result.data)
            })
        }
    }, [isMounted]);

    // 검색 컴포넌트 기능
    // 검색어 입력 핸들러
    const handleSearchChange = (inputValue) => {
        setSearchKeyword(inputValue);
    };

    // 검색어가 변경될 때마다 상품 리스트 필터링
    useEffect(() => {
        if (!searchKeyword) {
            setFilteredProducts(products); // 검색어가 없으면 모든 상품을 표시
        } else {
            // 검색어가 있으면 해당 검색어를 포함하는 상품만 필터링하여 표시
            const filtered = products.filter(product => 
                product.productName.toLowerCase().includes(searchKeyword.toLowerCase())
            );
            setFilteredProducts(filtered);
        }
    }, [searchKeyword, products]); // searchKeyword 또는 products가 변경될 때마다 실행

    return (
        <div style={{paddingTop: pagePaddTopH}}>
            <Container padding={pageCommonPadd} height={mainBodyHeight}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" height={"initial"} padding={mainPadd}>
                        {/* H1 헤더 */}
                        <P size={pageH1FontSize}>상품관리</P>
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 검색 창 */}
                        <AdminMobileSearchInput placeholder="상품을 검색해보세요." onSearch={handleSearchChange} />
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 탭 버튼 기능 */}
                        <AdminMobileTabbtnBox
                            categories={categories}
                            selectedCategory={selectedCategory}
                            setSelectedCategory={setSelectedCategory}
                        />
                    </FlexChild>
                    <FlexChild>
                        {/* 상품 리스트 출력 */}
                        <AdminMobileProductList products={filteredProducts} />
                    </FlexChild>
                </VerticalFlex>
                {/* 등록 페이지 이동 버튼 */}
                <AdminMobileRegisterBtn to="/admin/mobile/product/register" />
            </Container>
        </div>
    );
};

export default AdminMobileStoreProduct;